// PLACEHOLDER: substituir pela URL real da plataforma ou WhatsApp oficial.
export const CTA_URL = "https://salonup.com.br";

export const NAV_ITEMS = [
  { label: "Gestão", href: "#gestao", testId: "nav-gestao" },
  { label: "Comercial", href: "#comercial", testId: "nav-comercial" },
  { label: "Inteligência", href: "#inteligencia", testId: "nav-inteligencia" },
];
